// extracted by mini-css-extract-plugin
export default {"icon":"BackToTopButton__icon--3c1","wrapper":"BackToTopButton__wrapper--2Iu"};